import { FormGroup } from '@angular/forms';
import { Injectable, OnInit, signal } from '@angular/core';
import { FormGroupModel } from '../../shared/models/custom-types';

@Injectable()
export abstract class BaseFormComponent<T extends FormGroupModel<T>>
  implements OnInit
{
  protected formGroup = signal<FormGroup<T>>({} as FormGroup<T>);

  ngOnInit(): void {
    this.#initFg();
  }

  #initFg(): void {
    this.formGroup.set(this.createFormGroup());
  }

  protected abstract createFormGroup(): FormGroup<T>;
}
